import { CASTypes } from '../../../cimsPage/instances/cas'
import { Types } from '../../common'

const types = Types({
  page: CASTypes,
  create: '053DDB2F-73C8-44E5-959C-F26997B28F06',
  view: 'D15B97F9-C085-4617-9F69-A638650D3A69',
  edit: '61AF0C6F-DB85-4C9A-AE0D-D347F96E43BC',
  removeRestore: 'A6601C94-F914-4F8B-8A59-F8A52597A3CB',
})

export const CreateCASType = types.Create
export const ViewCASType = types.View
export const EditCASType = types.Edit
export const RemoveRestoreCASType = types.RemoveRestore

export type CASTypePermission =
  | typeof CreateCASType
  | typeof ViewCASType
  | typeof EditCASType
  | typeof RemoveRestoreCASType
